module.exports = __webpack_public_path__ + "img/name.0a234d6a.png";